
/**************************************
  CARD PRODUCT VARIANT (CPV) — FIXED
**************************************/

document.addEventListener("DOMContentLoaded", function () {
  initCPVForms();

  const observer = new MutationObserver(() => {
    initCPVForms();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/* --------------------------------------------------
   CLEAN NULL / EMPTY VALUES
--------------------------------------------------*/
function cleanOptions(arr) {
  return arr.filter(v => v && v !== "" && v !== "null");
}

/* --------------------------------------------------
   INIT ALL CPV FORMS
--------------------------------------------------*/
function initCPVForms() {
  document.querySelectorAll(".cpv-form").forEach((form) => {
    if (form.dataset.cpvInit === "true") return;
    form.dataset.cpvInit = "true";

    initCPVOptionButtons(form);
    initCPVFormSubmit(form);
    autoSelectFirstCPVOptions(form);
    updateCPVSelectedVariant(form);
  });
}

/* --------------------------------------------------
   ON CLICK → UPDATE SELECTION
--------------------------------------------------*/
function initCPVOptionButtons(form) {
  form.querySelectorAll(".cpv-radio").forEach((radio) => {
    radio.addEventListener("change", () => {
      updateCPVSelectedVariant(form);
    });
  });
}

/* --------------------------------------------------
   AUTO SELECT FIRST AVAILABLE
--------------------------------------------------*/
function autoSelectFirstCPVOptions(form) {
  form.querySelectorAll(".cpv-variant-option").forEach((group) => {
    const firstRadio = group.querySelector(".cpv-radio:not(:disabled)");
    if (firstRadio) firstRadio.checked = true;
  });
}

/* --------------------------------------------------
   UPDATE OPTION AVAILABILITY
--------------------------------------------------*/
function updateCPVAvailability(form) {
  const productCard = form.closest(".card-product");
  const variants = JSON.parse(productCard.dataset.variants);

  const optionGroups = form.querySelectorAll(".cpv-variant-option");

  optionGroups.forEach((group, optionIndex) => {
    const radios = group.querySelectorAll(".cpv-radio");

    radios.forEach((radio) => {
      const optionValue = radio.value;

      const testOptions = [];

      form.querySelectorAll(".cpv-radio:checked").forEach((el) => {
        const idx = parseInt(el.name.replace("cpv-option-", "")) - 1;
        testOptions[idx] = el.value;
      });

      testOptions[optionIndex] = optionValue;

      const isAvailable = variants.some((variant) => {
        return (
          JSON.stringify(cleanOptions(variant.options)) ===
          JSON.stringify(cleanOptions(testOptions)) &&
          variant.available
        );
      });

      if (isAvailable) {
        radio.disabled = false;
        radio.parentElement.classList.remove("cpv-disabled");
      } else {
        radio.disabled = true;
        radio.parentElement.classList.add("cpv-disabled");
      }
    });
  });
}

/* --------------------------------------------------
   UPDATE SELECTED VARIANT (ID + BUTTON)
--------------------------------------------------*/
function updateCPVSelectedVariant(form) {
  const productCard = form.closest(".card-product");
  const variants = JSON.parse(productCard.dataset.variants);

  const selectedOptions = [];

  form.querySelectorAll(".cpv-radio:checked").forEach((radio) => {
    selectedOptions.push(radio.value);
  });

  const matchedVariant = variants.find((variant) => {
    return (
      JSON.stringify(cleanOptions(variant.options)) ===
      JSON.stringify(cleanOptions(selectedOptions))
    );
  });

  if (matchedVariant) {
    const hidden = form.querySelector(".cpv-selected-variant-id");
    hidden.value = matchedVariant.id;

    const btn = form.querySelector(".cpv-add-to-cart-btn");

    if (matchedVariant.available) {
      btn.disabled = false;
      btn.innerHTML = "ADD TO CART";
    } else {
      btn.disabled = true;
      btn.innerHTML = "SOLD OUT";
    }
  }

  updateCPVAvailability(form);
}

/* --------------------------------------------------
   ADD TO CART SUBMIT
--------------------------------------------------*/
function initCPVFormSubmit(form) {
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const btn = form.querySelector(".cpv-add-to-cart-btn");
    const originalText = btn.innerHTML;

    btn.innerHTML = "Adding...";
    btn.disabled = true;

    const formData = new FormData(form);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        // 🔥 ફક્ત notification popup trigger કરો - drawer નહીં
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { addedItem: data }
        }));
      })
      .catch((error) => {
        console.error('Cart add error:', error);
      })
      .finally(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      });
  });
}

/* --------------------------------------------------
   SIMPLE PRODUCT: QTY + ADD → CART + DRAWER
--------------------------------------------------*/

document.addEventListener("click", function (event) {

  /* -------------------------
     QTY Increase
  -------------------------*/
  if (event.target.closest(".qty-increase")) {
    const wrapper = event.target.closest(".card-product--qty");
    const input = wrapper.querySelector(".card-product-quantity--input");
    input.value = parseInt(input.value) + 1;
  }

  /* -------------------------
     QTY Decrease
  -------------------------*/
  if (event.target.closest(".qty-decrease")) {
    const wrapper = event.target.closest(".card-product--qty");
    const input = wrapper.querySelector(".card-product-quantity--input");
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  }

  /* -------------------------
     ADD TO CART
  -------------------------*/
  if (event.target.closest(".card-product-add--btn")) {
    const btn = event.target.closest(".card-product-add--btn");
    const card = btn.closest(".card-product");
    const qtyWrapper = btn.closest(".card-product--qty");
    const qty = qtyWrapper.querySelector(".card-product-quantity--input").value;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.innerHTML = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(qty),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // 🔥 ફક્ત notification popup trigger કરો - drawer નહીં
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { addedItem: data }
        }));
      })
      .catch((error) => {
        console.error('Cart add error:', error);
        alert('Error adding to cart. Please try again.');
      })
      .finally(() => {
        btn.disabled = false;
        btn.innerHTML = `Add 
        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.46 11.9362L19.9142 4.30183H4.90703L6.36121 11.9362H18.4594H18.46ZM15.7638 13.6743C16.3591 13.6743 16.8985 13.9166 17.2894 14.3078C17.6796 14.699 17.9213 15.2397 17.9213 15.8372C17.9213 16.4346 17.6796 16.9753 17.2894 17.3665C16.8992 17.7577 16.3598 18 15.7638 18C15.1679 18 14.6285 17.7577 14.2383 17.3665C13.8481 16.9753 13.6064 16.4346 13.6064 15.8372C13.6064 15.2404 13.8481 14.6997 14.2383 14.3078C14.6285 13.9166 15.1679 13.6743 15.7638 13.6743ZM16.5931 15.0052C16.381 14.7925 16.0878 14.661 15.7638 14.661C15.4398 14.661 15.1467 14.7925 14.9339 15.0052C14.7217 15.2178 14.5906 15.5124 14.5906 15.8365C14.5906 16.1613 14.7217 16.4552 14.9339 16.6685C15.146 16.8812 15.4398 17.0127 15.7638 17.0127C16.0878 17.0127 16.381 16.8812 16.5931 16.6685C16.8053 16.4559 16.9364 16.1613 16.9364 15.8365C16.9364 15.5117 16.8053 15.2178 16.5931 15.0052ZM8.69226 13.6743C9.2882 13.6743 9.82757 13.9166 10.2178 14.3078C10.608 14.699 10.8497 15.2397 10.8497 15.8372C10.8497 16.4346 10.608 16.9753 10.2178 17.3665C9.82757 17.7577 9.2882 18 8.69226 18C8.09632 18 7.55695 17.7577 7.16673 17.3665C6.7765 16.9753 6.53478 16.4346 6.53478 15.8372C6.53478 15.2404 6.7765 14.6997 7.16673 14.3078C7.55695 13.9166 8.09632 13.6743 8.69226 13.6743ZM9.52156 15.0052C9.30942 14.7925 9.01627 14.661 8.69226 14.661C8.36825 14.661 8.0751 14.7925 7.86296 15.0052C7.65081 15.2178 7.51966 15.5117 7.51966 15.8365C7.51966 16.1613 7.65081 16.4552 7.86296 16.6685C8.0751 16.8812 8.36825 17.0127 8.69226 17.0127C9.01627 17.0127 9.30942 16.8812 9.52156 16.6685C9.73371 16.4559 9.86486 16.1613 9.86486 15.8365C9.86486 15.5117 9.73371 15.2178 9.52156 15.0052ZM3.82444 3.87132L3.27479 0.986681H0.491796C0.219862 0.986681 0 0.765628 0 0.493018C0 0.220408 0.220505 0 0.491796 0H3.68108V0.000644483C3.91251 0.000644483 4.11887 0.164339 4.16388 0.400859L4.71932 3.31579H20.5089V3.31643C20.5391 3.31643 20.5699 3.31966 20.6008 3.32546C20.8676 3.37637 21.0425 3.6348 20.991 3.90161L19.3543 12.4924C19.3234 12.7353 19.1164 12.9235 18.8663 12.9235H5.95556V12.9229C5.72412 12.9229 5.51776 12.7592 5.47276 12.5227L3.83665 3.93255C3.83151 3.91257 3.82765 3.89259 3.82508 3.87197L3.82444 3.87132Z" fill="#870F6C"/>
        </svg>`;
      });
  }
});
